<template>
  <div>
    <!-- Top banner -->
    <div class="banner" v-bind:style="{ backgroundImage: 'url(' + acf.acf.about_banner + ')' }">
        <h1 class="majorHeading container">{{acf.acf.about_text_first_line}} <br> {{acf.acf.about_text_second_line}} <br> {{acf.acf.about_text_third_line}}</h1>
    </div>
    <!-- About Clutch Pro Tour -->
    <div class="pad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.about_header}}</h1>
                    <p v-html="acf.acf.about_paragraph"></p>
                </b-col>
                <b-col lg="6" sm="12">
                    <img class="aboutImage" :src="acf.acf.about_image">
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <!-- Our Mission and pathway -->
    <div class="backgroundGrey pad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.heading_one_mission}}</h1>
                    <p v-html="acf.acf.paragraph_one_mission"></p>
                </b-col>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.heading_two_pathway}}</h1>
                    <p v-html="acf.acf.paragraph_two_pathway"></p>
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <!-- Long Blue Banner -->
    <div class="blueBanner">
        <b-container>
            <h1 class="BannerText">{{acf.acf.blue_banner_text}}</h1>
        </b-container>
    </div>
    <!-- Inclusive by Design -->
    <div class="pad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <img class="aboutImage" :src="acf.acf.inclusive_image">
                </b-col>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.inclusive_header}}</h1>
                    <p v-html="acf.acf.inclusive_paragraphs"></p>
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <!-- Trusted by Partners -->
    <div class="backgroundGrey pad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.trusted_section_one_header}}</h1>
                    <p v-html="acf.acf.trusted_section_one_paragraph"></p>
                </b-col>
                <b-col lg="6" sm="12">
                    <h1 class="heading">{{acf.acf.our_vision_header}}</h1>
                    <p v-html="acf.acf.our_vision_paragraph"></p>
                </b-col>
            </b-row>     
        </b-container>
    </div>
    <!-- Tour Membership -->
    <MembershipBanner/>
  </div>

</template>

<script>
import axios from 'axios'
import MembershipBanner from "@/components/membershipBanner.vue";
export default {
  name: 'About Page',
  components: {
    MembershipBanner
  },
  data: function() {
    return {
      acf: [],
      acfMessage:''
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/1023"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
    .BannerText {
        font-size: 45px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .aboutImage {
        width: 100%;
    }
    .majorHeading {
        color: #FFFFFF;
        font-size: 65px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 200px;
    }
    .banner {
        width: 100%;
        height: 712px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .blueBanner {
        background-color: #081C3F;
        color: #fff;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .backgroundGrey {
        background-color: #F2F2F2;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    h1.heading {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p {
        font-size: 18px;
        color: #081C3F;
    }
    .pad {
        padding-top: 100px;
        padding-bottom: 100px;
    }
    @media only screen and (max-width: 1366px) {
        .banner {
            height: 512px;
        }
        .majorHeading {
            color: #FFFFFF;
            font-size: 65px;
            font-weight: bold;
            position: relative;
            top: 120px;
        }
    }
    @media only screen and (max-width: 1199px) {
        .majorHeading {
            display: none;
        }
    }
    @media only screen and (max-width: 510px) {
        .banner {
            width: 100%;
            height: 160px;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .pad {
            padding-top: 30px;
            padding-bottom: 30px;
        }
        h1.heading {
            padding-top: 20px;
            color: #081C3F;
            font-size: 36px;
            /* font-weight: bold; */
            padding-bottom: 30px;
            font-family: "brown-pro-condensed", sans-serif;
            font-weight: 800;
            font-style: normal;
        }
    }
</style>
